import { mapShade } from "./mapShade";
import { filterShades } from "../utils";
import { filterDiscontinuedShade } from "../utils/internal";
export var mapShades = function mapShades(shades) {
  if (shades) {
    return filterShades(shades).map(mapShade).filter(filterDiscontinuedShade);
  }
  return undefined;
};
//# sourceMappingURL=mapShades.js.map